const FormTemplatePermissionList = () =>
  import(/* webpackChunkName: "main_app" */ "./pages/ListPage.vue");
const FormTemplatePermissionDetail = () =>
  import(/* webpackChunkName: "main_app" */ "./pages/FormPage.vue");
const FormTemplatePermissionIndex = () =>
  import(/* webpackChunkName: "main_app" */ "./pages/IndexPage.vue");

export default [
  {
    path: "/form_template_permission",
    component: FormTemplatePermissionIndex,
    redirect: "/form_template_permission/list",
    name: "form_template_permission",
    children: [
      {
        path: "list",
        component: FormTemplatePermissionList,
        name: "form_template_permission.list",
      },
      {
        path: "create",
        component: FormTemplatePermissionDetail,
        name: "form_template_permission.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: FormTemplatePermissionDetail,
        name: "form_template_permission.edit",
        props: { create: false },
      },
    ],
  },
];
